module.exports = __webpack_public_path__ + "img/undraw_authentication_re_svpt.1c59361e.svg";